/**
 * Renders an atom icon in a gray rounded-square background.
 * The icon and color will be determined by the backend when GraphQL integration
 * lands (TREX-724). For now, uses a static blue accent color.
 */
import React from 'react';

import { cssMap } from '@atlaskit/css';
import AtomIcon from '@atlaskit/icon-lab/core/atom';
import { Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	iconBackground: {
		flexShrink: 0,
		backgroundColor: token('color.background.accent.gray.subtlest'),
		width: '32px',
		height: '32px',
		borderRadius: token('radius.tile'),
	},
});

/** Renders an atom icon inside a gray rounded-square. */
export const ThreadIcon = (): React.JSX.Element => {
	return (
		<Flex xcss={styles.iconBackground} alignItems="center" justifyContent="center">
			<AtomIcon label="" color={token('color.icon.accent.blue')} />
		</Flex>
	);
};
